import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Heart, ArrowLeft, Gift, Sparkles } from 'lucide-react';
import AppLogo from '../components/AppLogo';

const GiftIntroPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center px-5 py-12" data-testid="gift-intro-page">
      <div className="max-w-lg w-full">
        <button onClick={() => navigate('/individuals')} className="mb-8 text-muted-foreground hover:text-foreground transition-colors flex items-center gap-1.5 text-sm">
          <ArrowLeft className="w-4 h-4" /> Back
        </button>

        <div className="text-center space-y-8">
          <div className="space-y-6">
            <p className="text-xl sm:text-2xl text-foreground leading-relaxed font-medium">
              When cancer strikes someone you love, you don't know what to do.
            </p>

            <p className="text-lg text-foreground font-medium leading-relaxed">
              That's why I created <span className="font-semibold">CircleUpSquad</span><sup className="text-[7px] text-muted-foreground align-super">TM</sup>.
            </p>
          </div>

          <div className="surface-card p-6 rounded-2xl text-left space-y-4">
            <div className="flex items-start gap-4">
              <div className="w-20 h-20 rounded-full overflow-hidden border-2 border-cyan-200 dark:border-cyan-800 shadow-md flex-shrink-0">
                <img src="/images/shannon-portrait.jpg" alt="Shannon Ivey" className="w-full h-full object-cover bg-white" />
              </div>
              <div>
                <h2 className="text-lg font-bold text-foreground" style={{ fontFamily: 'Outfit, sans-serif' }}>Who am I?</h2>
                <p className="text-sm text-muted-foreground leading-relaxed mt-1">
                  I'm Shannon Ivey, and I wrote the book on person-centered care during cancer treatment.
                </p>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="https://uscpress.com/Welcome-to-the-Sh-t-Show"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm font-medium text-cyan-600 hover:text-cyan-700 underline underline-offset-4 transition-colors"
              >
                Find it here.
              </a>
              <span className="hidden sm:inline text-muted-foreground">|</span>
              <a
                href="https://youtu.be/SloEhSgZOQ4?si=XSia28ZBUN1mg3OY"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm font-medium text-cyan-600 hover:text-cyan-700 underline underline-offset-4 transition-colors"
              >
                And yes, I did a TEDx talk about it.
              </a>
            </div>
          </div>

          <p className="text-base text-foreground font-medium leading-relaxed">
            Here's how to give someone real support during cancer or survivorship:
          </p>

          <div className="space-y-4">
            <Button
              size="lg"
              className="btn-primary text-base w-full h-14"
              onClick={() => navigate('/gift')}
              data-testid="gift-app-btn"
            >
              <Gift className="w-5 h-5 mr-2" />
              Gift CircleUpSquad App
            </Button>

            <Button
              size="lg"
              className="w-full h-14 text-base bg-gradient-to-r from-cyan-500 to-emerald-500 hover:from-cyan-600 hover:to-emerald-600 text-white"
              onClick={() => navigate('/gift-coaching')}
              data-testid="gift-coaching-btn"
            >
              <Sparkles className="w-5 h-5 mr-2" />
              Gift CircleUpSquad App + Coaching
            </Button>

            <button
              onClick={() => navigate('/coach')}
              className="w-full surface-card rounded-xl p-5 text-center hover:border-cyan-300 dark:hover:border-cyan-700 transition-colors"
              data-testid="try-coaching-btn"
            >
              <p className="text-base font-semibold text-foreground">Want to try coaching?</p>
              <p className="text-xs text-muted-foreground mt-1">Meet Shannon — first session is free</p>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GiftIntroPage;
